const JWTService = {
    /**
     * Check if a JWT token is expired
     * @param {string} token - The JWT token to check.
     * @returns {boolean} - Returns `true` if the token is expired, `false` otherwise.
     */
    isTokenExpired(token) {
      try {
        if (!token) {
          console.error("Token is empty or undefined.");
          return true;
        }
  
        // Decode the token payload (Base64 decoding)
        const payloadBase64 = token.split('.')[1];
        if (!payloadBase64) {
          console.error("Invalid token format.");
          return true;
        }
  
        const payload = JSON.parse(atob(payloadBase64));
        const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
  
        // Check if the token's expiration time has passed
        return payload.exp < currentTime;
      } catch (error) {
        console.error("Error checking token expiration:", error);
        return true; // Assume expired if there's an error
      }
    },
  };
  
  export default JWTService;
  